import { Checkbox } from '@/components/Checkbox'
import cn from 'classnames'
import { SelectVariant } from '../..'
import styles from './Option.module.scss'
import { useCallback } from 'react'

interface OptionProps<TValue> {
  className?: string
  variant: SelectVariant
  label: string
  value: TValue
  isSelected: boolean
  size?: 'small' | 'medium' | 'large'
  onChange: (isSelected: boolean, value: TValue) => void
}
export const Option = <TValue,>({
  className,
  variant,
  label,
  value,
  isSelected,
  size = 'large',
  onChange,
}: OptionProps<TValue>) => {
  const change = useCallback(() => {
    onChange(!isSelected, value)
  }, [isSelected, value, onChange])

  return (
    <div
      className={cn(styles.option, className, {
        [styles.isSingleSelected]: variant === 'single' && isSelected,
        [styles.isSmall]: size === 'small',
      })}
      onClick={change}
    >
      {label}{' '}
      {variant === 'comboBox' || variant === 'comboText' ? (
        <Checkbox value={isSelected} className={styles.checkbox} />
      ) : null}
    </div>
  )
}
